import styled, { css, keyframes } from 'styled-components';

const StyledButton = styled.button`
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    background: white;

    margin: 0 auto;
    min-width: 120px;
    height: 40px;

    border: 1px solid rgba(126, 87, 194, 0.5);
    border-radius: 8px;

    flex: none;
    order: 0;
    flex-grow: 0;
    cursor: pointer;
    color: rgba(126, 87, 194, 1);
    font-weight: bold;

    // contained variant

    ${({ variant }) =>
            variant === 'contained' &&
            css`
                background: #7e57c2;
                color: white;
                box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
                0px 2px 2px rgba(0, 0, 0, 0.14),
                0px 1px 5px rgba(0, 0, 0, 0.12);
            `}
    ${({ variant }) =>
            variant === 'contained-flat' &&
            css`
                background: #7e57c2;
                color: white;
            `}
    &:hover {
        box-shadow: none;
        ${({ variant }) =>
                variant !== 'contained' &&
                variant !== 'contained-flat' &&
                css`
                    background: rgba(126, 87, 194, 0.05);
                `}
    }

    &:disabled {
        cursor: not-allowed;
        background: rgba(126, 87, 194, 0.2);
        color: rgba(126, 87, 194, 0.5);
        box-shadow: none;
        border: none;
    }

    ${({ color }) =>
            color &&
            css`
                background: #${color};
            `}

    ${({ txtColor }) =>
            txtColor &&
            css`
                color: #${txtColor};
            `}
`;

const Spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const Spinner = styled.svg`
    animation: ${Spin} 1s linear infinite;
`;

const Button = ({ children, loading, contained = 'outlined', color, txtColor, ...props }) => {
    return (
        <StyledButton
            variant={contained}
            color={color}
            txtColor={txtColor}
            {...props}
            disabled={loading || props.disabled}
        >
            {loading ? (
                <Spinner
                    width="13"
                    height="14"
                    viewBox="0 0 13 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.38798 12.616C3.36313 12.2306 2.46328 11.5721 1.78592 10.7118C1.10856 9.85153 0.679515 8.82231 0.545268 7.73564C0.411022 6.64897 0.576691 5.54628 1.02433 4.54704C1.47197 3.54779 2.1845 2.69009 3.08475 2.06684C3.98499 1.4436 5.03862 1.07858 6.13148 1.01133C7.22435 0.944078 8.31478 1.17716 9.28464 1.68533C10.2545 2.19349 11.0668 2.95736 11.6336 3.89419C12.2004 4.83101 12.5 5.90507 12.5 7"
                        stroke="white"
                    />
                </Spinner>
            ) : (
                children
            )}
        </StyledButton>
    );
};

export default Button;
